import React, { useRef, useEffect } from 'react';
import styles from './Alert.module.scss';

function Alert({ message, containerRef, ...other }){
    const msgRef = useRef(null);
  
    useEffect(() => {
      if( !message ) return;
  
      ( containerRef?.current || window ).scrollTo({
        top: msgRef.current.getBoundingClientRect().top,
        behavior: 'smooth'
      });
    }, [message, containerRef]);
  
    return !message ? null : (
      <p className={styles.alert} ref={msgRef} {...other}>
        {message}
      </p>
    )
  }
  

export default Alert;